export default __webpack_public_path__ + "static/media/download_p3.ab389a82.jpg";